// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mz-c";
export var backButton = "_mz-4";
export var backIcon = "_mz-5";
export var chevronShortcut = "_mz-6";
export var container = "_mz-1";
export var editor = "_mz-8";
export var editorWrapper = "_mz-7";
export var prefix = "_mz-2";
export var searchIcon = "_mz-3";
export var suffix = "_mz-9";
export var suffixContent = "_mz-a";
export var suffixText = "_mz-b";
export var wrapper = "_mz-0";